import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

pageHeaderStyles.gridItem = {
    width: 12,
    css: css`
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                `,
                css`
                    flex-direction: column;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};

pageHeaderStyles.buttonsWrapper = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};
